import React from 'react';
import { Heart, Phone } from 'lucide-react';

/**
 * @param {{ isDark: boolean; showEnglish: boolean; className?: string }} props
 */
export function BhriguCrisisCard({ isDark, showEnglish, className = '' }) {
  const card = isDark
    ? 'border-rose-400/40 bg-rose-950/40 text-rose-50'
    : 'border-rose-300 bg-rose-50 text-rose-950';

  return (
    <div className={`rounded-xl border p-4 ${card} ${className}`} role="alert">
      <div className="flex items-start gap-3">
        <Heart className="mt-0.5 h-5 w-5 shrink-0 text-rose-400" aria-hidden />
        <div>
          <p className="text-sm font-semibold leading-snug">
            {showEnglish
              ? 'AskGuru cannot help with thoughts of self-harm or suicide.'
              : 'AskGuru आत्म-हानि या आत्महत्या के विचारों पर मदद नहीं कर सकता।'}
          </p>
          <p className={`mt-2 text-sm leading-relaxed ${isDark ? 'text-rose-100/90' : 'text-rose-900/85'}`}>
            {showEnglish
              ? 'Please reach out to someone you trust or a crisis helpline. You matter.'
              : 'कृपया किसी विश्वसनीय व्यक्ति या संकट हेल्पलाइन से संपर्क करें।'}
          </p>
          <ul className={`mt-3 space-y-1.5 text-sm ${isDark ? 'text-rose-100' : 'text-rose-900'}`}>
            <li className="flex items-center gap-2">
              <Phone className="h-3.5 w-3.5 shrink-0" aria-hidden />
              iCall: 9152987821
            </li>
            <li className="flex items-center gap-2">
              <Phone className="h-3.5 w-3.5 shrink-0" aria-hidden />
              Vandrevala: 1860-2662-345
            </li>
            <li className="flex items-center gap-2">
              <Phone className="h-3.5 w-3.5 shrink-0" aria-hidden />
              {showEnglish ? 'Emergency: 112' : 'आपात: 112'}
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
